import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { IngresoRecursosParcial} from './IngresoRecursosParcial.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'IngresoRecursosParcial',
        component: IngresoRecursosParcial,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'IngresoRecursosParcial'
        } 
    }
];

@NgModule({
    declarations: [
        IngresoRecursosParcial
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        IngresoRecursosParcial
    ],
    bootstrap: [IngresoRecursosParcial]
})

export class IngresoRecursosParcialModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/IngresoRecursosParcial/IngresoRecursosParcial.module.ts